import api from './api';

export const simulationService = {
  getAll: async () => {
    return api.get('/simulations');
  },

  getById: async (simulationId) => {
    return api.get(`/simulations/${simulationId}`);
  },

  create: async (data) => {
    return api.post('/simulations', data);
  },

  update: async (simulationId, data) => {
    return api.put(`/simulations/${simulationId}`, data);
  },

  delete: async (simulationId) => {
    return api.delete(`/simulations/${simulationId}`);
  },

  addEvent: async (simulationId, event) => {
    return api.post(`/simulations/${simulationId}/events`, event);
  },

  removeEvent: async (simulationId, eventId) => {
    return api.delete(`/simulations/${simulationId}/events/${eventId}`);
  },

  calculate: async (simulationId) => {
    return api.get(`/simulations/${simulationId}/calculate`);
  },

  compare: async (simulationIds) => {
    return api.get('/simulations/compare', { params: { ids: simulationIds.join(',') } });
  },
};

export default simulationService;
